// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar/Navbar";
// import Gallery from "./components/pages/Gallery";
// import About from "./components/pages/About";
// import Home from "./components/pages/Home";
// import Locations from "./components/pages/Locations";
// import ContactUs from "./components/pages/ContactUs";
// import Enquiry from "./components/pages/Enquiry";


// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/gallery" element={<Gallery />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/locations" element={<Locations />} />
//         <Route path="/contact" element={<ContactUs />} />
      
//         <Route path="/enquiry" element={<Enquiry />} />
//       </Routes>  
//     </Router>
//   );
// }

// export default App;




import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Gallery from "./components/pages/Gallery";
import About from "./components/pages/About";
import Home from "./components/pages/Home";
import Locations from "./components/pages/Locations";
import ContactUs from "./components/pages/ContactUs";
import Enquiry from "./components/pages/Enquiry";
import Careers from "./components/pages/Careers"; // Import Careers page
import IndianGraniteExpress from "./components/pages/IndianGraniteExpress";
import InlandLogistics from "./components/pages/InlandLogistics";
import DryBulkCarriers from "./components/pages/DryBulkCarriers";
import IndianProjectExpress from "./components/pages/IndianProjectExpress";
import FreightForwarding from "./components/pages/FreightForwarding";
import LocationsInIndia from "./components/pages/LocationsInIndia";
import IndianSteelExpress from "./components/pages/IndianSteelExpress";
import Timberline from "./components/pages/Timberline";
import PrivacyStatement from "./components/pages/PrivacyStatement";
import TermsOfUse from "./components/pages/TermsOfUse";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/careers" element={<Careers />} /> {/* Careers page added */}
        <Route path="/indian-granite-express" element={<IndianGraniteExpress />} />
        <Route path="/inland-logistics" element={<InlandLogistics/>}/>
        {/* <Route path="/indiansteelexpress" element={<IndianSteelExpress/>} /> */}
        {/* <Route path="/dry-bulk-carriers" element={<DryBulkCarriers/>}/> */}
        <Route path="/indian-project-express" element={<IndianProjectExpress/>}/>
        <Route path="/freight-forwarding" element={<FreightForwarding />}/>
        <Route path="locationsinindaia" element={<LocationsInIndia />}/>
        <Route path="timberline" element={<Timberline />}/>
        <Route path="/indian-steel-express" element={<IndianSteelExpress />} />
        <Route path="/dry-bulk-carriers" element={<DryBulkCarriers />} />
        <Route path="/privacy-statement" element={<PrivacyStatement/>} />
        <Route path="/terms-of-use" element={<TermsOfUse/>} /> 
        
        


      </Routes>  
    </Router>
  );
}

export default App;
